<script>
import { initSheetClient } from './sheetclient.js';
import { tick } from 'svelte/internal';
import { clone, state, ui, res, prefs, resetStores } from './stores.js';
import { setUp, moveTo, doAction, allCards, starterActions, resetUniqueID } from './game.js';
import { loadAll, loadBotCharts } from './loader.js';
import { perfMeasureAsync } from './perf.js';
import { convert, isTouchDevice, waitMillis } from './ui.js';
import { loadGame, savePrefs, loadPrefs, uploadGame, uploadQueuedGames, exportSave, loadExported, loadReady, copyURL, makeUpload } from './save.js';
import STGame from './STGame.svelte';
import AdminPane from './AdminPane.svelte'
import Tiers from './Tiers.svelte'
import ParseInfo from './ParseInfo.svelte'
import Stats from './Stats.svelte'
import CampaignSummary from './CampaignSummary.svelte';
import CurrentGames from './CurrentGames.svelte';
import Select from 'svelte-select/Select.svelte';
import { poolGroups, poolItems, tidySelection, poolFromSelection, sameSelection } from './pool.js';
import { unlock, joinGame, setUsername, getUsername, numMultiPlayers, loadCampaigns, listenToRequests, initialiseFirebase } from './net.js';
import { onMount } from 'svelte/internal';
import { takeTurns, until } from './turns.js';
import { get, set } from 'idb-keyval';
import { botAvailableText, botLevels } from './bot.js';
import { campaignLevels, getCampaignBotLevel } from './campaign.js';
import { unparsedCard } from './card_actions.js';
    import { nanoid } from 'nanoid';
import { addCurrentGame, subToUpdates } from './sb.js';
    import { getGame, unsubscribeDB } from './anydb.js';
    import SandboxPick from './SandboxPick.svelte';
    import CommonsSelector from './CommonsSelector.svelte';
    import { allScoreableCards } from './scores.js';
    import CaptainSelector from './CaptainSelector.svelte';
    import { upperInitial } from './parse.js';
import SoloChallenge from './SoloChallenge.svelte';
import ScoreAnalysis from './ScoreAnalysis.svelte';
import LogCard from './LogCard.svelte';
import { applyPWAUpdate, registerPWA } from './pwa.js';

let mixinSets = ['Second Contact']; // Ideally these would be identified on the sheet somewhere, but manual for now

let tab = 'loading';
let subTab = 'new';
let password = '';
let connectingID = '';
let connectingPlayer = 1;
let provUN = '';
let exportedFile;

let tabs = ['setup', 'game', 'scoring'];
let numPlayers = 2;
let captainsAvailable = [];
let selectedCard;

let gameKey = false;
let showStagingSheet = false;
let showSeed = true;
let campaign = false;

$: savePrefs($prefs);

//$prefs.stagingSheet = false; // Todo could remove in future?
$prefs.customHandSize = false;

let origLog = console.log;
let origWarn = console.warn;

$: if($prefs.debugLogs || $prefs.useEruda){
    console.log = origLog;
    console.warn = origWarn;
}else{
    console.log = function () {};
    console.warn = function () {};
}

let resDate = false;
let preload = false;
let offline = !window.navigator.onLine;

onMount(() => {
    registerPWA();
    updateOfflineStatus();
    window.addEventListener('online', updateOfflineStatus);
    window.addEventListener('offline', updateOfflineStatus);
    return () => {
        window.removeEventListener('online', updateOfflineStatus);
        window.removeEventListener('offline', updateOfflineStatus);
    };
});

const urlParams = new URLSearchParams(window.location.search);
if(urlParams.has('preload')){
    console.log('preloading')
    preload = true;
}

$ui.loadedStatus = 'not';

/*get('username').then((val) => {
    un = val;
    $prefs.username = val;
    console.log(`Cached un: ${un}`);
    get('res').then((val) => {
        console.log(`Cached $res:`, val);
        if($ui.loadedStatus != 'live'){
            $res = {...$res, ...val};
            resetStores();
            captainsAvailable = $res.cards.filter(c => c.suits.includes('captain') && $res.dashboards.hasOwnProperty(c.deck)).map(c => c.deck);
            if($prefs.username) un = $prefs.username;
            if(preload){
                loadCardImages($res.cards, false, false);
                $ui.loadedStatus = 'cache';
            }
            if(preload || !window.navigator.onLine) $ui.tab = 'setup';
            checkParams();
        }
        
    }).catch((e) => {
        console.log('Error loading from cache:'+e);
    })
    get('resDate').then((val) => {
        resDate = val;
    })
}).catch((e) => {
    console.log('Error loading username:'+e);
})*/

async function restoreCachedRes(){
    let cached = await get('res');
    if(!cached || !cached.cards || cached.cards.length == 0) return false;
    await loadPrefs();
    $res = {...$res, ...cached};
    resetStores();
    $ui.unlocked = true;
    captainsAvailable = Array.from(new Set($res.cards.filter(c => c.suits.includes('captain') && !c.id.includes('B/') && $res.dashboards.hasOwnProperty(c.deck)).map(c => c.deck)));
    if($prefs.username) un = $prefs.username;
    resDate = await get('resDate');
    $ui.loadedStatus = 'cache';
    $ui.tab = 'setup';
    applyOfflineSetupDefaults();
    checkParams();
    return true;
}

function updateOfflineStatus(){
    offline = !window.navigator.onLine;
    if(offline){
        applyOfflineSetupDefaults();
    }else{
        retryQueuedUploads();
    }
}

function applyOfflineSetupDefaults(){
    if(!offline) return;
    if(subTab == 'games') subTab = 'new';
    if($ui.tab != 'setup' || subTab != 'new') return;
    state.update(s => {
        // Offline defaults are only setup defaults; never rewrite an active/loaded game.
        if(s.startDate) return s;
        if(s.players && s.players[1] && !s.practice){
            s.players[1].bot = true;
            if(!s.players[1].botLevel) s.players[1].botLevel = 'Commander (Level 3)';
        }
        return s;
    });
}

function retryQueuedUploads(){
    if(offline || $ui.loadedStatus == 'not') return;
    uploadQueuedGames({quiet: true}).catch(e => console.log('Unable to upload queued games: '+e.message));
}

async function doLoad(){
    if($ui.loadedStatus == 'live') return;
    if(!window.navigator.onLine && await restoreCachedRes()) return;
    loadAll().then(ret => {
        //$res = {...$res, ...ret};
        
        console.log($res.cards.filter(c => c.suits.includes('captain')));
        captainsAvailable = Array.from(new Set($res.cards.filter(c => c.suits.includes('captain') && !c.id.includes('B/') && $res.dashboards.hasOwnProperty(c.deck)).map(c => c.deck)));
        $ui.loadedStatus = 'live';
        $ui.loadingDetail = 'setting up multiplayer'
        console.log('all bits', $res, $state)
        console.log('captains available', captainsAvailable);
        getUsername().then((u) => {
            un = u;
            if($ui.tab == 'loading') $ui.tab = 'setup';
            delete $ui.loadingDetail;
            checkParams();
            saveRes();
            retryQueuedUploads();
            if(u) set('username', u).then((s) => {
                console.log('username', u);
            });  
        });
    }).catch(async (error) => {
        console.log('Unable to load live data', error);
        ui.update(ui => {
            ui.liveDataError = error.message || error;
            return ui;
        })
        if(!await restoreCachedRes()) throw error;
    });
}

async function saveRes(){
    await set('res', $res);
    await set('resDate', new Date());
    console.log('New res cached');
}

async function installPWA(){
    if(!$ui.installPrompt) return;
    let promptEvent = $ui.installPrompt;
    $ui.installPrompt = null;
    promptEvent.prompt();
    await promptEvent.userChoice;
}

let campaignChoices = [];

async function forgetLocalCampaign(){
    campaign = false;
    await loadCampaign(false)
}

async function loadCampaign(getLocal = true){
    if(getLocal) campaign = await get('campaign');
    /*if(!campaign.captain){
        campaign.captain = 'Koloth';
        set('campaign', campaign);
    }*/
    campaignChoices = await loadCampaigns('only ongoing');
    if(campaignChoices.length > 0){
        if(campaign){
            if(!campaign.key && campaign.games.length > 0) campaign.key = campaign.games[0].key;
            if(campaignChoices.some(c => c.key == campaign.key)){
                // Duplicate, so pick longer of them
                let duplicates = [campaign, ...campaignChoices].filter(c => c.key == campaign.key).sort((a,b) => b.games.length - a.games.length);
                campaign = duplicates[0];
            }
            campaignChoices = campaignChoices.filter(c => c.key != campaign.key); // Avoid duplicates
            campaignChoices = [campaign, ...campaignChoices];
        }else{
            campaign = campaignChoices[0];
        }
    }else if(campaign){
        campaignChoices = [campaign];
    }
    updateCampaign(); // To sync player info
}

function updateCampaign(){
    if(campaign){
        $state.players[0].captain = campaign.captain;
        console.log(campaign);
    }
    checkCaptains(0);
}

function wipeCampaign(){
    if(!confirm('Really erase your campaign and start over?')) return;
    campaign = false;
    set('campaign', campaign);
}

let showCampaign = true;

function checkParams(){
    let params = new URLSearchParams(window.location.search);
    let key = params.get('key');
    if(key){
        gameKey = key;
        subTab = 'stats';
    }

    if(params.get('staging')) showStagingSheet = true;
    if(params.get('campaign')) showCampaign = true;
    if(params.get('invite')){
        if(offline){
            subTab = 'new';
            return;
        }
        let id = params.get('invite');
        let captain = params.get('captain');
        joinGame(id, captain);     
    }
    if(params.get('reloadParser')){
        $ui.reloadParser = true;
    }
    if(params.get('seed')){
        $state.random.seed = params.get('seed');
    }
}

function loadExport(){
    if(exportedFile.length == 0) return;
    let f = exportedFile[0];
    let reader = new FileReader();
    reader.onload = e => {
        let savedJSON = e.target.result;
        if(loadExported(savedJSON)) $ui.tab = 'game';
    };
    reader.readAsText(f, 'UTF-8');
}

function loadAndRestart(){
    if(exportedFile.length == 0) return;
    let f = exportedFile[0];
    let reader = new FileReader();
    reader.onload = e => {
        let savedJSON = e.target.result;
        if(loadExported(savedJSON)){
            console.log($prefs);
            $state = $res.initialState;
            $res.savedState = clone($state);
            $res.deltas = [];
            $res.undos = [];
            $ui.tab = 'game';
        }
    };
    reader.readAsText(f, 'UTF-8');
}

function availableCards(cards){
    let filteredCards = cards.filter(c => c && c.id && ($res.selectedCommons.includes(c.box) || $res.mixinSets[c.box]));///c.id.startsWith(s.ref)));
    return filteredCards;
}

function getUnparsedCommonsCount(cards){
    // commons = $res.selectedCommons
    //let cards = availableCards($res.cards, $res.sets);
    cards = cards.filter(c => c.deck == 'Common' || c.deck == 'Locations');
    return cards.filter(c => unparsedCard(c)).length;
}

async function startGame(){
    if(!await getUsername()) await setUsername();
    // campaign keeps whatever was picked in the dropdown after the box is unticked:
    // only a campaign game should take its captain and campaign info
    if(campaign && $state.campaign){
        if(campaign.captain) $state.players[0].captain = campaign.captain;
        $state.campaignInfo = {
            ...campaign,
            captain: $state.players[0].captain,
            username: $prefs.username,
            ended: false
        };
    }
    $state = await setUp($state, availableCards($res.cards, $res.sets));
    if($prefs.shareGames != 'Never'){
        if(!$state.players.some(p => p.bot) && !$state.practice || $prefs.shareGames == 'Always'){
            $state.advertised = true;
            if(await addCurrentGame($state, $ui)){
                //$ui.synced = true;
                await subToUpdates($state.gameID);
                await listenToRequests($state.gameID);
            }
        }
    }
    
    if($res.BvB){
        await takeTurns();
    }else{
        $ui.tab = 'game';
        await tick();
    }
   
    ui.update(u => {
        u.animate = true;
        return u;
    });
}

function availableCaptains(){
    //console.log('AC: ', captainsAvailable.filter(c => availableCards($res.cards, $res.sets).some(cd => cd.deck == c)) )
    return captainsAvailable; // .filter(c => availableCards($res.cards, $res.sets).some(cd => cd.deck == c)) 
}

function cardsFromSet(set, beta = false){
    //console.log(set.name, $res.cards.filter(c => c && c.id && c.id.startsWith(set.ref)))
    let cards = $res.cards.filter(c => c && c.id && c.id.startsWith(set.ref));
    if(beta){
        cards = cards.filter(c => c.staging && c.staging.toUpperCase().trim() == 'BETA')
    }else if(!$res.betaCards){
        cards = cards.filter(c => !c.staging);
    }
    return cards;
}

async function checkCaptains(i){
    //await tick(); // To let them sync
    let p = $state.players[i];
    if(!p.bot){
        if(p.captain == 'Janeway' && !p.bot){
            $state.players[i].dashSide = 'journey';
        }else{
            $state.players[i].dashSide = 'advanced';
        }
    }
    
    //console.log('checking')
    for(let j = 0; j < $state.players.length; j++){
        if(j == i) continue;
        let o = $state.players[j];
        if(o.captain == p.captain){
            //console.log('clash');
            let options = availableCaptains();
            $state.players[j].captain = options.find(o => !$state.players.some((p,j) => p.captain == o.captain));
        }
    }
}

async function loadSave(ready = false){
    if(ready && await loadReady(ready) || await loadGame()){
        $ui.tab = 'game';
    }
}

// The score screen reads per-card scores from the breakdown: scoring often runs on a copy of
// the player, so the cards themselves may not carry them
function notScored(p, c){
    return (p.scoreBreakdown.notScored || []).includes(c.uniqueID);
}

function focusScore(p, c){
    if(!p.scoreBreakdown.focus) return c.trackScore || 0;
    return p.scoreBreakdown.focus[c.uniqueID] || 0;
}

function endgameScore(p, c){
    let specific = p.scoreBreakdown.endGameSpecific || {};
    let key = (c.id || '').replace('/', '_');
    return specific.hasOwnProperty(key) ? specific[key] : c.endGameScore;
}

function moveToScoring(){
    if($ui.tab != 'scoring'){
        $ui.tab = 'scoring'; 
        if(liveGameComponent) liveGameComponent.$destroy();
    }
}

$: if($ui.unlocked) set('unlocked', true);

async function moveToSetup(){
    if($ui.tab != 'setup'){
        $ui.tab = 'setup';
        if(liveGameComponent) liveGameComponent.$destroy();
        if($ui.peer) $ui.peer.destroy();
        await tick();
        //console.log($ui.peer);
        if($state.advertised) unsubscribeDB('current_games', 'nanoid', $state.gameID);
        resetStores();
        resetUniqueID();
        $ui.unlocked = true;
    }
}

// Every await inside a BvB game resolves as a microtask, so the main thread never
// returns to the event loop and the browser never repaints - the progress counter sits
// frozen until the whole run ends. setTimeout is a macrotask, which lets a paint through.
// Throttled, so the yield costs ~4ms per 100ms rather than once per game.
let lastUIYield = 0;
async function yieldToUI(){
    if(Date.now() - lastUIYield < 100) return;
    lastUIYield = Date.now();
    await waitMillis(0);
}

async function waitForGameEnd(ms = 3000){
    let deadline = Date.now() + ms;
    while(!$state.ended && Date.now() < deadline) await waitMillis(20);
    return $state.ended;
}

async function playMatchup(p1, p2, level, times = 1){
    let results = [];
    for(let i = 0; i < times; i++){
        await tick();
        
        resetStores();
        resetUniqueID();
        $ui.unlocked = true;
        $state.players[0].captain = p1;
        $state.players[0].bot = true;
        $state.players[1].captain = p2;
        $state.players[1].bot = true;
        $state.players[0].botLevel = level;
        $state.players[1].botLevel = level;
        $res.BvB = true;
        rrDone++;
        await tick();
        await yieldToUI(); // so the progress counter actually paints during the run
        console.log('resetting game', $res, $state);
        // Denominator: whole-game wall clock, to compare against the measured innards
        await perfMeasureAsync('bvb.wholeGame', () => startGame());

        // startGame resolves when takeTurns does. If a turn loop is somehow still
        // running, reading winners now records a half-played game and the next
        // resetStores() pulls the state out from under it. Normally already true, so
        // this costs nothing; bounded so a game that dies can't stall the whole run.
        // console.error, not warn: warn is nulled while BvB runs
        if(!await waitForGameEnd()) console.error(`BvB: ${p1} v ${p2} never ended - result may be partial`);

        for(let p of $state.players){
            if(!rrCaptains[p.captain]) rrCaptains[p.captain] = {
                won: 0,
                drew: 0,
                played: 0
            }
            rrCaptains[p.captain].played++;
            if($state.winners.length == 2){
                rrCaptains[p.captain].drew++;
            }else if($state.winners.includes(p.captain)){
                rrCaptains[p.captain].won++;
            }
        }
        
        // Don't save replays for now, could reenable if we want to later
        results.push(makeUpload($state));
    }
    
    return results;
}

// Must be a real level, not undefined: bind:value on a <select> doesn't pick the
// first option, and a bot with no botLevel throws in setupStardates.
let rrLevel = botLevels()[0];
let rrError = false;
let rrTimes = 10;
let rrDone = false;
let bbTypes = [
    {
        name: 'Round Robin (all captains)',
        value: 'robin',
    },
    {
        name: 'One v many',
        value: '1vM'
    },
    {
        name: 'Specific matchup',
        value: 'specific'
    }/*,
    {
        name: 'April fools',
        value: 'april'
    }*/
];
let bbChosen = 'robin';
let rrCaptains = {};
let rrTotalGames = 0;
let rrGames = [];

// Which captains round robin / one-v-many draw from. One multiselect holding two
// kinds of chip: a whole box (carries .decks) or a single captain. rrPool is derived.
let rrSelection = [];
let rrPoolInit = false;

$: rrPoolGroups = poolGroups(captainsAvailable, $res.botCharts, $res.sets || []);
$: rrPoolAll = rrPoolGroups.flatMap(g => g.decks);
$: rrPoolItems = poolItems(rrPoolGroups);
$: rrPool = poolFromSelection(rrSelection);
$: if(!rrPoolInit && rrPoolGroups.length > 0){
    rrSelection = rrPoolItems.filter(i => i.decks); // default: every box
    rrPoolInit = true;
}

// NB one-way value + on:input, never bind:value. Select reassigns its own `value`
// on every pass, so a two-way binding plus any assignment here spins forever
// (it hung the whole BvB tab). Same reason for the sameSelection early return.
function pickPool(detail){
    let next = tidySelection(detail || []);
    if(sameSelection(next, rrSelection)) return;
    rrSelection = next;
}

function resetBvB(){
    rrDone = false;
    rrCaptains = {};
    rrGames = [];
    rrError = false;
}

async function playOnePairing(p1, p2){
    let matchups = [];
    rrDone = false;
    matchups.push([p1, p2]);
    matchups.push([p2, p1]);
    await executeMatchups(matchups);
}

async function playOneVMany(p1) {
    let captains = rrPool.filter(c => rrPoolAll.includes(c));
    let matchups = [];
    rrDone = false;
    for(let c of captains){
        if(p1 == c) continue;
        matchups.push([p1, c]);
        matchups.push([c, p1]);
    }
    await executeMatchups(matchups);
}

async function executeMatchups(matchups){
    rrDone = false;
    rrTotalGames = matchups.length * rrTimes;
    let savedDebugLogs = $prefs.debugLogs;
    $prefs.debugLogs = false;
    await tick();
    let allLevels = botLevels();
    if(rrLevel == -1) rrTotalGames = rrTotalGames * allLevels.length;
    let results = [];
    rrCaptains = {};
    rrDone = 0;
    try{
        if(rrLevel == -1){
            for (let l of allLevels){
                for(let m of matchups){
                    results.push(...await playMatchup(m[0], m[1], l, rrTimes));
                }
            }
        }else{
            for(let m of matchups){
                results.push(...await playMatchup(m[0], m[1], rrLevel, rrTimes));
            }
        }
        rrDone = 'done';
        rrGames = results;
    }catch(e){
        // Without this a failed game leaves the run parked on the progress screen with
        // no way back, and console.log/warn are nulled below, so nothing is visible.
        console.error('BvB run failed', e);
        rrError = (e && e.message) || String(e);
        rrGames = results;
        rrDone = results.length > 0 ? 'done' : false;
    }finally{
        $res.BvB = false;
        $prefs.debugLogs = savedDebugLogs;
    }
}

async function playRoundRobin(){
    // Prune here rather than reactively: the pool can outlive a bot chart reload
    let captains = rrPool.filter(c => rrPoolAll.includes(c));
    let matchups = [];
    rrDone = false;
    for(let c of captains){
        for (let d of captains){
            if(c == d) continue;
            if(matchups.some(m => m.some(y => y == c) && m.some(z => z == d))) continue;
            matchups.push([c, d]);
            matchups.push([d, c]);
        }
    }
    await executeMatchups(matchups);
}

async function playAprilFool(){
    let captains = ['Picard', 'Sela', 'Sisko' /*sass*/, 'Koloth' /*cult*/, 'Burnham' /*zet*/, 'Shran' /*wookies*/]
    let conversion = {
        Sisko: 'Sassanids',
        Koloth: 'Cultists',
        Burnham: 'Zet',
        Shran: 'Wookies'
    }
    let matchups = [];
    rrDone = false;
    for(let c of captains){
        for (let d of captains){
            if(c == d) continue;
            if(matchups.some(m => m.some(y => y == c) && m.some(z => z == d))) continue;
            matchups.push([c, d]);
            matchups.push([d, c]);
        }
    }
    await executeMatchups(matchups);
    for(let g of rrGames){
        for(let p of g.players){
            if(conversion[p.captain]) p.captain = conversion[p.captain];
        }
        let w = [];
        for(let win of g.winners){
            if(conversion[win]){
                w.push(conversion[win]);
            }else{
                w.push(win);
            }
        }
        g.winners = w;
    }
}

let ready = true;

async function reloadSheet(){
    ready = false;
    console.log('Reloading sheet info');
    await loadAll(true);
    console.log('Reloaded');
    ready = true;
}
/*async function observeGame(){
    if(!await getUsername()) await setUsername();

}*/

let connecting = false;

function minsAgo(earlyTime, laterTime){
    let diff = laterTime - earlyTime;
    diff = diff / (1000 * 60);
    return Math.round(diff);
}

let liveGameComponent;
let un;

</script>
<svelte:head>
    {#if window.navigator.onLine}
        <script on:load={initSheetClient} async defer src="https://apis.google.com/js/api.js"></script>
    {/if}
    {#if $prefs.useEruda}
		<script src="https://cdn.jsdelivr.net/npm/eruda" on:load={e => { eruda.init(); }}></script>
	{/if}
</svelte:head>
<!--<div class="main">
    <div class="cardlist">
        <CardGen facedown c={$state.commons.market[0]} />
        {#each $state.commons.market_zone as c}
            <CardGen {c} />
        {/each}
        <CardGen facedown c={$state.commons.locations[0]} />
        {#each $state.commons.neutral_zone as c}
            <CardGen {c} />
        {/each}
    </div>
</div>-->
{#if !$ui.unlocked}
    Enter password: <input type="password" bind:value={password} on:change={e => {unlock(password).then((res) => {if(res) doLoad()});}}/><button on:click={e => {unlock(password).then((res) => {if(res) doLoad()});}}>Go!</button>
<!--{:else if $ui.tab == 'loading'}-->
{:else if $ui.loadedStatus == 'not'}
    Loading...
    {#if $ui.loadingDetail} {$ui.loadingDetail} {/if}
    {#if $ui.loadingProgress} ({$ui.loadingProgress.toFixed(0)}%){/if}
{:else if $ui.tab == 'setup'}
        <h1>Star Trek: Captain's Chair</h1>
        <div class="version">{$res.version}</div>
        {#if $ui.pwaUpdateReady}
            <div class="pwa_notice">
                Update ready.
                <button on:click={applyPWAUpdate}>Reload</button>
            </div>
        {/if}
        {#if $ui.installPrompt}
            <div class="pwa_notice">
                Offline app available.
                <button on:click={installPWA}>Install</button>
            </div>
        {/if}
        {#if un}
            Welcome back, {un}!
            <button on:click={async (e) => {await setUsername(); un = await getUsername();}}>Change username</button>
        {:else}
            Set username: <input type="text" bind:value={provUN} /><button on:click={async (e) => {await setUsername(provUN); un = await getUsername();}}>Set</button>
        {/if}
        {#if $ui.loadedStatus == 'cache'}
            <div style="font-weight: bold; color: yellow;">
                <div>Using cached data {#if resDate} from {resDate}{/if}.</div>
                {#if !offline}
                    {#if $ui.liveDataError}
                        <div>Error loading live data: {$ui.liveDataError}</div>
                    {:else}
                        <div>Live data still loading... {#if $ui.loadingDetail} {$ui.loadingDetail} {/if} {#if $ui.loadingProgress} ({$ui.loadingProgress.toFixed(0)}%){/if}</div>
                    {/if}
                {/if}
            </div>
        {/if}
        <div>
            <button class='tab' class:selected={subTab == 'new'} on:click={e => subTab = 'new'}>New game</button>
            <button class='tab' class:selected={subTab == 'save'} on:click={e => subTab = 'save'}>Load save</button>
            {#if !offline}
                <button class='tab' class:selected={subTab == 'games'} on:click={e => { subTab = 'games'} }>Online games</button>
                <button class='tab' class:selected={subTab == 'stats'} on:click={e => subTab = 'stats'}>Stats</button>
            {/if}
            <button class='tab' class:selected={subTab == 'bvb'} on:click={e => subTab = 'bvb'}>BvB</button>
            <button class='tab' class:selected={subTab == 'admin'} on:click={e => { subTab = 'admin'} }>Card admin</button>
            <button class='tab' class:selected={$ui.tab == 'tiers'} on:click={e => { $ui.tab = 'tiers'} }>Tiers list</button>
            <button class='tab' class:selected={subTab == 'parser'} on:click={e => { subTab = 'parser'} }>Parser debug</button>
        </div>
        <hr />
        {#if subTab == 'new'}
            <input type="checkbox" bind:checked={$state.practice} /> Cadet training mode (no second player)?
            {#if showCampaign}
                <div>
                    <input type="checkbox" bind:checked={$state.campaign} on:change={e => {checkCaptains(0)}} /> Campaign game?
                </div>
            {/if}    
            {#if $state.campaign}
                {#await loadCampaign()}
                    Loading...
                {:then}
                    {#if campaignChoices && campaignChoices.length > 0}
                        <div>
                            Select campaign:
                            <select bind:value={campaign} on:change={updateCampaign}>
                                {#each campaignChoices as c}
                                    <option value={c}>{c.currentRank} {c.captain}, game {c.games.length + 1}: {c.level}</option>
                                {/each}
                                <option value={false}>Start new campaign</option>
                            </select>
                        </div>
                    {/if}
                    <button on:click={forgetLocalCampaign}>Reload campaigns from server</button>(use if local campaign seems out of sync with your progress)
                    {#if campaign}
                        <CampaignSummary c={campaign} />
                    {:else}
                        Start new campaign of level:
                        <select bind:value={$state.campaignInfo.level}>
                           {#each Object.keys(campaignLevels) as l}
                                <option value={l}>{l}</option>
                           {/each}
                        </select>
                        <div>
                            Select any challenge(s) you wish you add to the campaign (see <a href="https://docs.google.com/document/d/1NpCdhG2-6drFMcD82QVReePfIan7aa_7kflozZUXMpE/edit#">Rulebook</a> for full details, most untested as yet):
                            <div>
                                <input type="checkbox" bind:checked={$state.campaignInfo.liveLong} /> Live Long and Try to Prosper (resources decrease after wins)
                            </div>
                            <div>
                                <input type="checkbox" bind:checked={$state.campaignInfo.logProper} /> Live Log and Proper (shuffle reserve and starter decks once you hit Lieutenant)
                            </div>
                            <div>
                                <input type="checkbox" bind:checked={$state.campaignInfo.twoWeeks} /> Two Weeks to the Nearest Outpost (<i>Reinforce</i> goes to Reserve after win)
                            </div>
                            <div>
                                <input type="checkbox" bind:checked={$state.campaignInfo.gazelle} /> Running Like a Baby Gazelle (add Incident to deck after winning two games in a row)
                            </div>
                            <div>
                                <input type="checkbox" bind:checked={$state.campaignInfo.acquire} /> Rules of Acquisition (can't add from Reserve if you win a game)
                            </div>
                            <div>
                                <input type="checkbox" bind:checked={$state.campaignInfo.onlyShip} /> Only Ship in the Quadrant (you lose immediately if your starting ship is dismissed/recalled)
                            </div>
                            <div>
                                <input type="checkbox" bind:checked={$state.campaignInfo.onTuesday} /> They Will Arrive on Tuesday (set aside Away Team until Reserve is empty, 2 after win)
                            </div>
                        </div>
                    {/if}
                {/await}
            {/if}
            {#each $state.players as p, i}
                {#if i == 0 || !$state.practice}
                    <div>
                        Player {i + 1}: 
                        {#if campaign && $state.campaign}
                            {#if i == 0}
                                {campaign.captain}
                            {:else}
                                <select bind:value={$state.players[i].captain}>
                                    {#each captainsAvailable.filter(c => c != campaign.captain && !campaign.games.some(g => g.enemy == c && g.won) && $res.botCharts.hasOwnProperty(c)) as c}
                                        <option value={c} disabled={!captainsAvailable.includes(c)}> <!--/*!availableCards($res.cards, $res.sets).some(cd => cd.deck == c)*/-->
                                            {c}
                                            {#if i != 0} {botAvailableText(c)}{/if}
                                        </option>
                                    {/each}
                                </select>
                            {/if}
                        {:else}
                           <!--<select bind:value={$state.players[i].captain} on:change={e => {checkCaptains(i)}}>
                                {#each captainsAvailable as c}
                                    <option value={c} disabled={!captainsAvailable.includes(c)}> 
                                        {c}
                                        {#if $res.botCharts.hasOwnProperty(c)} (bot available) {/if}
                                        {#if $res.cards.filter(cd => cd.deck == c).some(cd => unparsedCard(cd))}
                                            - warning, {$res.cards.filter(cd => cd.deck == c && unparsedCard(cd)).length} cards don't parse yet
                                        {/if}
                                    </option>
                                {/each}
                            </select>--> 
                            <CaptainSelector bind:value={$state.players[i].captain} i={i} available={captainsAvailable} change={e => {checkCaptains(i)}} />
                        {/if}
                        {#if !p.bot}
                            Dashboard side:
                            <select bind:value={p.dashSide}>
                                {#if p.captain == 'Janeway'}
                                    <option value="journey">Journey</option>
                                {/if}
                                <option value="advanced">Advanced</option>
                                {#if !['Khan', 'Borg Queen', 'Q'].includes(p.captain)}
                                    <option value="basic">Basic</option>
                                {/if}
                            </select>
                        {/if}
                        <!--<input type="checkbox" bind:checked={p.dummy} /> Dummy bot (acts randomly)?-->
                        {#if $state.campaign && campaign}
                            {#if i == 1} Bot level: {getCampaignBotLevel(campaign.currentRank, campaign.level)}
                                <SandboxPick bind:ready={ready} bind:captainsAvailable={captainsAvailable} />
                                <!--<div>
                                    <input type="checkbox" bind:checked={$state.useConspiracy} />Add 'Conspiracy' card to Bot deck (to up difficulty)?
                                </div>-->
                                <SoloChallenge />
                            {/if}
                        {:else}
                            {#if $state.campaign}
                                {#if i == 1} 
                                    Starting bot level: {getCampaignBotLevel(0, $state.campaignInfo.level)}
                                    <SandboxPick bind:ready={ready} bind:captainsAvailable={captainsAvailable} />
                                {/if}
                            {:else}
                                {#if i == 1 && $res.botCharts.hasOwnProperty($state.players[i].captain)}
                                    
                                    <input type="checkbox" bind:checked={p.bot} /> Bot? (Name of bot: '{$res.botCharts[$state.players[i].captain].chartName}')
                                    {#if p.bot}
                                        Bot level:
                                        <select bind:value={p.botLevel}>
                                            {#each botLevels() as l}
                                                <option value={l}>{l}</option>
                                            {/each}
                                        </select>
                                        <SandboxPick bind:ready={ready} bind:captainsAvailable={captainsAvailable} />
                                        <!--<div>
                                            <input type="checkbox" bind:checked={$state.useConspiracy} /> Add 'Conspiracy' card to Bot deck (to up difficulty)?
                                        </div>-->
                                        <SoloChallenge />
                                    {/if}
                                {/if}
                            {/if}
                        {/if}
                    </div>
                {/if}
            {/each}
            {#if $state.campaign && !$res.campaignRewards[$state.players[1].captain]}
                <div class="warning">
                    Warning: {$state.players[1].captain} campaign rewards unavailable - fix parsing error before continuing with this game
                </div>
            {/if}
            
            {#if $state.players.every(p => p.bot)}
                <input type="checkbox" bind:checked={$res.BvB} /> Play in BvB mode, i.e. no screen display, just for stats?
                <input type="checkbox" bind:checked={$prefs.debugLogs} />Log console messages? (Will slow things down)
            {/if}
            <!--{#if $res.sets.filter(s => cardsFromSet(s).length > 0).length > 0}
                <div>
                    Sets to include:
                    <ul style="list-style-type: none;">
                        {#each $res.sets as s, i}
                            {#if cardsFromSet(s).length && parseInt(s.ref) != 1}
                                <li>
                                    <input type="checkbox" bind:checked={s.selected} on:change={e => {if(cardsFromSet(s).length < cardsFromSet(s, true).length && !$res.betaCards) $res.betaCards = true;} } /> {s.name} ({cardsFromSet(s).length} cards available{#if cardsFromSet(s, true).length > 0 && !$res.betaCards} &nbsp; + {cardsFromSet(s,true).length} beta cards{/if})
                                </li>
                            {/if}
                        {/each}
                    </ul>
                </div>
            {/if}-->
            <!--<div>
                Use commons from:
                <select bind:value={$res.selectedCommons} on:change={e => {$res.sets.forEach(s => {if(s.name == $res.selectedCommons) s.selected = true; else s.selected = false;}); console.log($res.sets);}} >
                    {#each $res.sets.filter(s => !mixinSets.includes(s.name)) as s}
                        <option value={s.name}>{s.name} ({cardsFromSet(s).length} cards, {$res.cards.filter(cd => cd.box == s.name && unparsedCard(cd)).length} unparsed)</option>
                    {/each}
                </select>
            </div>
            
            <div>
                Add expansion cards to commons?
                {#each $res.sets.filter(s => mixinSets.includes(s.name)) as s}
                    <div>
                        <input type="checkbox" bind:checked={$res.mixinSets[s.name]} /> {s.name} ({cardsFromSet(s).length} cards, {$res.cards.filter(cd => cd.box == s.name && unparsedCard(cd)).length} unparsed)
                    </div>
                {/each}
            </div>
            -->
            <CommonsSelector captains={$state.practice ? [$state.players[0].captain] : $state.players.map(p => p.captain)} />
            {#if getUnparsedCommonsCount(availableCards($res.cards, $res.sets)) > 0}
                <div style="color: yellow;">Warning: {getUnparsedCommonsCount(availableCards($res.cards, $res.sets))} Commons cards not yet parsing</div>
            {/if}
            <hr />
            <div>
                <input type="checkbox" bind:checked={$res.krulmuth} /> Force Krulmuth-B into the locations?
            </div>
            {#if showSeed}
                <div>
                    Game seed (to allow repeatable setups): 
                    <input type="text" bind:value={$state.random.seed} />
                </div>
            {/if}
            
            <!--<div>
                <input type="checkbox" bind:checked={$res.betaCards} /> Include beta cards? ({$res.cards.filter(c => c.staging == 'BETA').length} available)
            </div>-->
            
            <!--<div>
                <input type="checkbox" bind:checked={$res.alphaCards} /> Include alpha cards (just for fun)? ({$res.cards.filter(c => c.staging == 'ALFA').length} available)
            </div>-->
            {#if isTouchDevice(false)}
                <div>
                    I think you are using a touchscreen device (e.g. a tablet), and have thus disabled normal clicks to speed up touch detection. 
                    If you are not, or are using a hybrid (e.g. laptop with touch screen), select here to avoid issues with clicks being ignored:
                    <input type="checkbox" bind:checked={$prefs.forceNotTouch} />
                </div>
            {/if}
            <!--<button on:click={reloadSheet}>Force reload images (click if you get old cards in the game)</button>
            
            <h3>Rule tweaks</h3>
            <div>
                Number of starter locations on top of deck (i.e. beyond opening 3):
                <select bind:value={$prefs.starterLocations}>
                    <option value={5}>2 extra</option>
                    <option value={4}>1 extra</option>
                    <option value={3}>0 extra (just 3 in opening market)</option>   
                </select>
            </div>-->
            <!--<div>
                <input type="checkbox" bind:checked={$res.shorterTurns} />Shorter turns variant (more glory on stardate cards, 2 actions per turn)
            </div>-->
            <!--<div>
                <input type="checkbox" bind:checked={$prefs.customHandSize} /> Alter hand size?
                {#if $prefs.customHandSize}
                    <div>
                        Hand for first turn: <input type="number" bind:value={$prefs.starterHandSize} /> cards
                    </div>
                    <div>
                        Subsequent hand size: <input type="number" bind:value={$prefs.normalHandSize} /> cards
                    </div>
                {/if}
            </div>
            <div>
                <input type="checkbox" bind:checked={$prefs.gainToDeck} /> Gain cards to top of deck?
            </div>-->
            {#if showStagingSheet}
                <div>
                    <input type="checkbox" bind:checked={$res.stagingSheet} on:change={reloadSheet} /> Use temporary 'staging' spreadsheet? (For testing alternative variants)
                    Staging sheet ID: <input type="text" bind:value={$res.stagingID} /><button on:click={reloadSheet}>Reload sheet</button>
                </div>
            {/if}
            
            {#if ready}
                <div>
                    <button on:click={startGame}>Launch!</button>
                </div>
            {:else}
                Reloading data...
            {/if}
        {:else if subTab == 'save'}
            <div>
                Load exported game: <input type="file" bind:files={exportedFile} /><button on:click={loadExport}>Load</button>
            </div>
            <div>
                Load exported game and start from turn 0 (for debug purposes): <input type="file" bind:files={exportedFile} /><button on:click={loadAndRestart}>Load</button>
            </div>
            <hr />
            {#await get('default')}
                Checking for saved game...
            {:then game}
                {#if game}
                    Saved game{game.whenSaved ? ' (from '+new Date(game.whenSaved).toLocaleString()+')': ''} ready to load
                    <button on:click={e => {loadSave(game)}}>Load</button>
                    <div>
                        <button on:click={e => {exportSave()}}>Export saved game (e.g. for debugging purposes)</button>
                    </div>
                {:else}
                    No saved game found
                {/if}
            <!--<div>
                <button on:click={e => {loadSave()}}>Attempt to load saved game (if there)</button>
            </div>-->
            {/await}
            
        {:else if subTab == 'stats'}
            <Stats {gameKey} />  
        {:else if subTab == 'bvb'}
            {#if rrDone == false}
                Type of BvB play:
                <select bind:value={bbChosen}>
                    {#each bbTypes as b}
                        <option value={b.value}>{b.name}</option>
                    {/each}
                </select>
                <div>
                    <input type="checkbox" bind:checked={$res.saveReplays} /> Save full log/state data? (Allows viewing of individual game logs, but is slower and more memory-intensive)
                </div>
                <div>
                    <input type="checkbox" bind:checked={$res.bvbBurn} /> Allow Burn? (If unchecked, taking the last incident won't end the game)
                </div>
                {#if bbChosen == 'specific'}
                    {#each [0, 1] as i}
                        <div>
                            Player {i+1} captain: 
                            <select bind:value={$state.players[i].captain} on:change={e => {checkCaptains(i)}}>
                                {#each captainsAvailable.filter(c => $res.botCharts.hasOwnProperty(c)) as c}
                                    <option value={c} disabled={!captainsAvailable.includes(c)}> <!--disabled={!availableCards($res.cards, $res.sets).some(cd => cd.deck == c)}-->
                                        {c}
                                        {#if $res.cards.filter(cd => cd.deck == c).some(cd => unparsedCard(cd))}
                                            - warning, {$res.cards.filter(cd => cd.deck == c && unparsedCard(cd)).length} cards don't parse yet
                                        {/if}
                                    </option>
                                {/each}
                            </select>
                        </div>
                    {/each}
                {:else if bbChosen == '1vM'}
                    <div>
                        Player 1 captain: 
                        <select bind:value={$state.players[0].captain} on:change={e => {checkCaptains(0)}}>
                            {#each captainsAvailable.filter(c => $res.botCharts.hasOwnProperty(c)) as c}
                                <option value={c} disabled={!captainsAvailable.includes(c)}> <!--disabled={!availableCards($res.cards, $res.sets).some(cd => cd.deck == c)}-->
                                    {c}
                                    {#if $res.cards.filter(cd => cd.deck == c).some(cd => unparsedCard(cd))}
                                        - warning, {$res.cards.filter(cd => cd.deck == c && unparsedCard(cd)).length} cards don't parse yet
                                    {/if}
                                </option>
                            {/each}
                        </select>
                    </div>
                {/if}

                {#if bbChosen == 'robin' || bbChosen == '1vM'}
                    <div>
                        Captain pool ({rrPool.length} of {rrPoolAll.length}{#if bbChosen == '1vM'}, opponents for player 1{/if}):
                        <div class="multiselect">
                            <Select containerStyles="color: black;" value={rrSelection} items={rrPoolItems}
                                    multiple={true} clearable={true} groupBy={i => i.group}
                                    on:input={e => pickPool(e.detail)}
                                    on:clear={e => { if(Array.isArray(e.detail)) pickPool([]); }}
                                    placeholder="Pick whole boxes or individual captains">
                                <span slot="selection" let:selection class:box_chip={!!selection.decks}>
                                    {selection.label}{#if selection.decks} ({selection.decks.length}){/if}
                                </span>
                                <span slot="item" let:item class:box_item={!!item.decks}>
                                    {#if item.decks}All of {item.label} ({item.decks.length}){:else}{item.label}{/if}
                                </span>
                            </Select>
                        </div>
                    </div>
                {/if}

                <div>
                    <input type='number' bind:value={rrTimes} min={1} max={100} /> games per pairing (note that AvB and BvA are separate pairings, to avoid any first-player advantage)
                </div>
                <div>
                    Bot level:
                    <select bind:value={rrLevel}>
                        {#each botLevels() as l}
                            <option value={l}>{l}</option>
                        {/each}
                        <option value={-1}>All levels sequentially (warning: lots of games!)</option>
                    </select>
                </div>
                <SandboxPick bind:ready={ready} bind:captainsAvailable={captainsAvailable} />
                <CommonsSelector captains={$state.players.map(p => p.captain)} />
                <!--<div>
                    Use commons from:
                    <select bind:value={$res.selectedCommons} on:change={e => {$res.sets.forEach(s => {if(s.name == $res.selectedCommons) s.selected = true; else s.selected = false;}); console.log($res.sets);}} >
                        {#each $res.sets.filter(s => !mixinSets.includes(s.name)) as s}
                            <option value={s.name}>{s.name} ({cardsFromSet(s).length} cards, {$res.cards.filter(cd => cd.box == s.name && unparsedCard(cd)).length} unparsed)</option>
                        {/each}
                    </select>
                </div>
                
                <div>
                    Add expansion cards to commons?
                    {#each $res.sets.filter(s => mixinSets.includes(s.name)) as s}
                        <div>
                            <input type="checkbox" bind:checked={$res.mixinSets[s.name]} /> {s.name} ({cardsFromSet(s).length} cards, {$res.cards.filter(cd => cd.box == s.name && unparsedCard(cd)).length} unparsed)
                        </div>
                    {/each}
                </div>-->
                <hr />
                {#if ready}
                    {#if bbChosen == 'robin'}
                        <button on:click={playRoundRobin} disabled={rrPool.length < 2}>Start Round Robin!</button>
                        {#if rrPool.length < 2}<span>Pick at least 2 captains for the pool.</span>{/if}
                    {:else if bbChosen == 'april'}
                        <button on:click={playAprilFool}>Start April Fool!</button>
                    {:else if bbChosen == '1vM'}
                    <button on:click={e => {playOneVMany($state.players[0].captain)}} disabled={rrPool.filter(c => c != $state.players[0].captain).length == 0}>Play matches!</button>
                    {#if rrPool.filter(c => c != $state.players[0].captain).length == 0}<span>Pick at least 1 opponent for the pool.</span>{/if}
                    {:else if bbChosen == 'specific'}
                        <button on:click={e => {playOnePairing($state.players[0].captain, $state.players[1].captain)}}>Play matches!</button>
                    {/if}
                {/if}
                {#if rrError}
                    <div style="font-weight: bold; color: red;">BvB run stopped: {rrError} (see console for the stack)</div>
                {/if}
            {:else if rrDone == 'done'}
                <div>
                    <button on:click={resetBvB}>Reset BvB</button>
                </div>
                Results:
                    <Stats providedGames={rrGames} />
            {:else}
                Playing game {rrDone} of {rrTotalGames} ({(Math.round(rrDone/rrTotalGames * 100))}%)
                <div>
                    Current match-up: {$state.players[0].captain} v {$state.players[1].captain}
                </div>
                <div>Turn {$state.turn}, active player {$state.players[$state.activePlayer].captain}, scores {$state.players[0].score}-{$state.players[1].score}</div>
                <!--<div>
                    {#each [0, 1] as i}
                        {$state.players[i].captain} has {allScoreableCards($state.players[i]).length} cards{#if i == 0}, {/if}
                    {/each}
                </div>-->
                <div>
                    Win rate so far:
                    <ul>
                        {#each Object.keys(rrCaptains) as k}
                            <li>{k}: {rrCaptains[k].won} of {rrCaptains[k].played} ({Math.round(rrCaptains[k].won / rrCaptains[k].played * 100)}%)
                        {/each}
                    </ul>
                </div>
            {/if}
        {:else if subTab == 'admin'}
            <AdminPane />
        {:else if subTab == 'parser'}
            <ParseInfo />
        {:else if subTab == 'games'}
            <CurrentGames />
        {/if}
{:else if $ui.tab == 'tiers'}
    <Tiers bind:this={liveGameComponent} on:setup={moveToSetup}/>
{:else if $ui.tab == 'game'}
    <STGame bind:this={liveGameComponent} on:end={moveToScoring} on:setup={moveToSetup}/>
{:else if $ui.tab == 'scoring'}
    <div class="scoring">
        {#each $state.players as p, i}
            <div class="score_player" style="background-color: {i == 0 ? 'darkblue' : 'darkred'};">
                <div>
                    <div class="score_captain">
                        {p.captain}: {@html convert(`${p.score}`)}
                    </div>
                    <div class="score_breakdown">Score breakdown:</div>
                    <div class="score_item">
                        {@html convert(`[[glory]]`)}Glory: {p.scoreBreakdown.glory}
                    </div>
                    <div class="score_item">
                        {@html convert(`[[away team]]/[[ship]]`)} in NZ: {p.scoreBreakdown.locationScoring}
                    </div>
                    <div class="score_item">
                        <details>
                            <summary>Endgame scoring: {p.scoreBreakdown.endGame}</summary>
                            <div class="card_list">
                                {#each allScoreableCards(p, true).filter(c => endgameScore(p, c)) as c}
                                    <LogCard showFinalScores showStats clickable category="conditional" textSize={1.5} c={{...c, score: endgameScore(p, c), endGameScore: endgameScore(p, c)}} />
                                {/each}
                            </div>
                        </details>
                    </div>
                    <div class="score_item">
                        <details>
                            <summary>Focus scoring: {p.scoreBreakdown.tracks}</summary>
                            <div class="card_list">
                                {#each allScoreableCards(p, true).filter(c => c.stripe) as c}
                                    <LogCard showFinalScores showStats clickable category="multiplier" textSize={1.5} c={{...c, score: focusScore(p, c), trackScore: focusScore(p, c)}} />
                                {/each}
                            </div>
                        </details>
                    </div>
                    <div class="score_item">
                        <details>
                            <summary>Missions: {allScoreableCards(p, true).filter(c => c.dashMission && c.complete).reduce((a,c) => a + (c.score || c.vp), 0)}</summary>
                            <div class="card_list">
                                {#each allScoreableCards(p, true).filter(c => c.dashMission && c.complete) as c}
                                    <LogCard showFinalScores showStats clickable textSize={1.5} {c} />
                                {/each}
                            </div>
                        </details>
                    </div>
                    <div class="score_item">
                        <details>
                            <summary>Other cards: {allScoreableCards(p, true).filter(c => !c.dashMission && c.vp && !notScored(p, c)).reduce((a,c) => a + c.vp, 0)}</summary>
                            <div class="card_list">
                                {#each allScoreableCards(p, true).filter(c => !c.dashMission && c.vp) as c}
                                    {#if notScored(p, c)}
                                        <!-- e.g. the Borg Queen's 'You only score for ...' leaves it out -->
                                        <span class="not_scored" title="Does not score"><LogCard showFinalScores showStats clickable textSize={1.5} fakeScore="0" {c} /></span>
                                    {:else}
                                        <LogCard showFinalScores showStats category="flat" clickable textSize={1.5} {c} />
                                    {/if}
                                {/each}
                            </div>
                        </details>
                    </div>
                    <!--{#each Object.keys(p.scoreBreakdown) as k}
                        {#if k == 'endGame'}
                            <div class="score_item">
                                    Endgame goals: {p.scoreBreakdown.endGame}
                                    ({#each Object.keys(p.scoreBreakdown.endGameSpecific) as id, i}
                                        {id}: {p.scoreBreakdown.endGameSpecific[id]}
                                        {#if i < Object.keys(p.scoreBreakdown.endGameSpecific).length - 1},{/if}
                                    {/each})
                            </div>
                        {:else if k != 'endGameSpecific' && k != 'individualCards'}
                            <div class="score_item">
                                {k.slice(0, 1).toUpperCase()}{k.slice(1)}: {p.scoreBreakdown[k]}
                            </div>
                        {/if}
                    {/each}-->
                    <div class="score_breakdown">Stats:</div>
                    {#each Object.keys(p.stats.cardsGained) as k}
                        <div class="score_item">
                            {#if k == 'none'}
                                Cards of no suit gained:
                            {:else if k != 'redshirt'}
                                {@html convert(`${k}`, true)} cards gained:
                            {:else}
                                {k} cards gained:
                            {/if}
                            {p.stats.cardsGained[k]}
                        </div>
                    {/each}
                </div>
            </div>
            <!-- next: replace with below -->
            <!-- <ScoreAnalysis> {p} cards={allScoreableCards(p, true)} />-->
            {#if i < $state.players.length - 1}
                <div class="separator" />
            {/if}
        {/each}
    </div>
    <div class="winner">
        {#if $state.winners}
            Winner{$state.winners.length > 1 ? 's' : ''}: {$state.winners.join(', ')}
        {:else}
            Draw!
        {/if}
    </div>
    <div>
        <h2>Stats</h2>
        <div>
            Turns: {$state.turn}
        </div>
        <div>
            Market card breakdown: 
            <select bind:value={selectedCard}>
                {#each allCards(true) as c}
                    {#if c.deck == 'Common' || c.deck == 'Locations'}
                        <option value={c}>{c.name} ({c.id}) 
                            {#if c.entered && typeof c.entered.turn == 'number' && c.left && typeof c.left.turn == 'number'}
                                – in market {c.left.turn - c.entered.turn} turns
                            {/if}
                        </option>
                    {/if}
                {/each}
            </select>
            {#if selectedCard}
                {#each [selectedCard] as c}
                    {c.name} ({c.id}):
                        {#if c.entered && typeof c.entered.turn == 'number'}
                            came on to {c.entered.location} turn {c.entered.turn},
                            {#if c.left && typeof c.left.turn == 'number'}
                                left market to go to {c.left.location} turn {c.left.turn}
                            {:else}
                                never left market
                            {/if}
                        {:else}
                            never entered market
                        {/if}  
                {/each}
            {/if}
        </div>
    </div>
    {#if $state.uploaded}
        Game already uploaded to server
        <button on:click={e => copyURL($state.uploaded)}>Copy to clipboard</button>
    <!--{:else if numMultiPlayers() > 1 &&  $state.hostPeer != $ui.peerID}
        Only the game host can upload a multiplayer game to the server-->
    {:else}
        <button on:click={uploadGame}>Upload results to server</button>
    {/if}
    <div>
        <button on:click={e => {exportSave()}}>Export game file (in case of any problems uploading)</button>
    </div>
    <div>
        <button on:click={e => {$ui.backToSetup()}}>Return to home screen</button>
    </div>
{/if}
<style>
 .tab {
    color: white;
    background-color: blue;
    border: 5px solid white;
 }

 .winner {
    font-size: 2em;
    font-weight: bold;
    text-align: center;
 }

 .selected {
    /*color: white;
    background-color: blue;*/
    background-color: darkblue;
    color: yellow;
    border: 5px solid yellow;
 }

 .scoring {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    justify-content: space-between;
    
 }

 .score_player {
    margin-bottom: 10px;
    padding-bottom: 10px;
    width: 100%;
 }

 .separator {
    background-color: white;
    min-width: 5px;
    min-height: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    margin-bottom: 0;
 }

 .score_captain {
    font-weight: bold;
    border-bottom: 5px solid white;
 }

 .score_breakdown {
    font-style: italic;
 }

 .score_item {
    margin-left: 20px;
 }

table, th, td {
    border: 1px solid white;
    border-collapse: collapse;
}

.center {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.table_label {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;

}

.warning {
    font-weight: bold;
    color: red;
}

.pwa_notice {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 4px 0 8px;
    padding: 6px 8px;
    border: 2px solid #7aa7ff;
    background: #071733;
    color: white;
}

.version {
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 0.8em;
    text-align: right;
    font-style: italic;
}

.multiselect {
    --multiItemActiveBG: blue;
    --multiItemActiveColor: white;
    --multiItemBG: lightgrey;
    --itemHoverBG: blue;
    --itemHoverColor: white;
    --itemColor: black;
    --groupTitleColor: #444;
    --groupTitleTextTransform: uppercase;
    display: block;
    max-width: 700px;
    margin-bottom: 8px;
}

/* Whole-box chips read as a set, not a captain */
.box_chip {
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 0.9em;
}

.box_item {
    font-weight: bold;
}

.not_scored {
    opacity: 0.45;
}
</style>
